import "./scss/app.scss";
import app from "./js/app.js";
import react from "./react/index";

(function () {
	react.init();

	(app.init as () => void)();

})();